import { render, staticRenderFns } from "./AuthVisualShell.vue?vue&type=template&id=5e5df840"
import script from "./AuthVisualShell.vue?vue&type=script&lang=js"
export * from "./AuthVisualShell.vue?vue&type=script&lang=js"
import style0 from "./AuthVisualShell.vue?vue&type=style&index=0&id=5e5df840&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports